<template>
<div class="tabBox">
    <div v-if="memberPostContent && memberPostContent.length>0">
      <table>
        <tr v-for="item in memberPostContent" :key="item">
          <td> {{getBranchName(item.branchCode)}}
            </td>
          <td>{{getIdentityType(item.post)}}</td>
        </tr>
      </table>
    </div>
    <div class="noBox" v-else>
       <template>暂无数据！</template>
    </div>
</div>
</template>

<script>
import {getMemberPost,getBranchs,getUser,getDictionaryByCode} from "@/api/dictionary";
import { mapState, mapGetters, mapActions ,mapMutations} from "vuex";
export default {
  props: {
      memberId: {
            type: String,
            default: null
        },
  },
  data() {
    return {
      memberPostContent:[],
      branchList:[],
      identityTypeList:[],
      userInfo:{}
    }
  },
  created() {

  },
  methods: {
    getBranchName(code){
     let obj = this.branchList.filter(item => item.code == code);
     return obj && obj[0] && obj[0].name;
    },
    getIdentityType(value){
       let obj = this.identityTypeList.filter(item => item.value == value);
       return obj.length? obj[0].name : null;
    }
  },
  mounted() {
    getDictionaryByCode("IDENTITY_TYPE")
    .then(res =>{
        if(res.success){
            this.identityTypeList = res.result;
        }
    })

    getBranchs()
        .then(res =>{
            if(res.success){
                this.branchList = res.result;

            }
        })
	getUser().then(res=>{
			if (res.success) {
               this.userInfo = res.result;
                     if(this.userInfo.id){
                        getMemberPost({memberId:this.userInfo.id})
                            .then(res =>{
                                if(res.success){
                                    this.memberPostContent = res.result;

                                }
                            })
                    }
			}
        })


    }
}
</script>

<style lang="less">
  .el-upload--text {
    border: none
  }
.tabBox table { margin-top: -1px;}
.tabBox table td{ font-size: 15px; margin: 0; color: #000; padding:10px 0 }
table{width:100%;text-align:center;border-collapse:collapse;border-spacing:1;border-spacing:0; }
table td{word-break: break-all; word-wrap:break-word;border:1px solid #dfdfdf; width: 50%;}
.noBox{ border:#dfdfdf solid 1px; border-top: none; padding: 10px; text-align: center;}
</style>
